import { Button, Form, Input, message } from 'antd'
import Title from 'antd/es/typography/Title'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppAdmin } from 'api/app-admin'
import { logInfo } from 'utils/logger'
import { isValidPassword } from 'utils/validate-fields'

export default function UpdatePassword() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [isWrongPassword, setIsWrongPassword] = useState(false)

  const handleSubmit = async (values: { oldPassword: string; newPassword: string }) => {
    try {
      const response = await AppAdmin.changePassword(values)
      logInfo('response', response)
      if (response.data.code === 201) {
        message.success('Password changed successfully. Please log in again.')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('userName')
        sessionStorage.removeItem('role')
        navigate('/login')
      }
    } catch (error: any) {
      if (error.message === 'password invalid') {
        setIsWrongPassword(true)
      }
    }
  }

  return (
    <>
      <div
        style={{
          maxWidth: 400,
          margin: '50px auto 50px',
          padding: '20px',
          border: '1px solid #d9d9d9',
          backgroundColor: 'white',
        }}
      >
        <Title level={2}>Update Password</Title>

        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item
            name="oldPassword"
            label="Old Password"
            validateStatus={isWrongPassword ? 'error' : ''}
            help={isWrongPassword ? 'The old password is incorrect. Please try again.' : ''}
            rules={[
              {
                required: true,
                message: 'Please input your old password!',
              },
              {
                validator(_) {
                  if (isWrongPassword) {
                    return Promise.reject('The old password is incorrect. Please try again.')
                  }

                  return Promise.resolve()
                },
              },
            ]}
          >
            <Input.Password placeholder="Enter your old password" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New password"
            rules={[
              {
                required: true,
                message: 'Please input your new password!',
              },
              {
                validator(_, value) {
                  if (value === form.getFieldValue('oldPassword')) {
                    return Promise.reject(
                      'The new password cannot be the same as the old password!'
                    )
                  }

                  if (isValidPassword(value) === false) {
                    return Promise.reject(
                      'Passwords must be 8-256 characters long and contain at least one number, one lowercase letter, one uppercase letter, and one special character.'
                    )
                  }

                  return Promise.resolve()
                },
              },
            ]}
          >
            <Input.Password placeholder="Enter your new password" />
          </Form.Item>
          <Form.Item
            name="newPasswordAgain"
            label="New password again"
            rules={[
              {
                required: true,
                message: 'Please input your new password again!',
              },
              {
                validator(_, value) {
                  if (value === form.getFieldValue('newPassword')) {
                    return Promise.resolve()
                  }

                  return Promise.reject(new Error('This password does not match the new password.'))
                },
              },
            ]}
          >
            <Input.Password placeholder="Enter your new password again" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Confirm new password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  )
}
